import { useQuery } from "@tanstack/react-query";
import { presentationApi } from "./axios";
import {
    DataI,
    ServiceResponseI,
    PresentationI,
    PropsGroupsI,
} from '../../interfaces';
import {
    ValidateCurrentToken,
    LogoutSystem,
} from '../../helpers';
import { AxiosError } from 'axios';

const getAllPresentations = async ({
    pagination,
    sorting,
    globalFilter,
    line,
    supplier
}: PropsGroupsI): Promise<ServiceResponseI<DataI<PresentationI>>> => {

    try {

        const validateToken = ValidateCurrentToken();

        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const params = new URLSearchParams();

        params.append('page', (pagination!.pageIndex + 1).toString());
        params.append('limit', pagination!.pageSize.toString());
        globalFilter && params.append('search', globalFilter);
        sorting && params.append('sorting', JSON.stringify(sorting));
        line && params.append('line', JSON.stringify(line));
        supplier && params.append('supplier', JSON.stringify(supplier));

        //headers: { 'Authorization': validateToken
        const { data } = await presentationApi.get<ServiceResponseI<DataI<PresentationI>>>('', { params, headers: { 'Authorization': validateToken } });
        return data;

    } catch (err) {
        const obj = (err as AxiosError).response;

        if (obj?.status === 401) {
            
            LogoutSystem();
        }

        throw new Error((err as Error).message)
    }


}

export const getAllPresentationsNoPagination = async () => {

    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');

        const { data } = await presentationApi.get("/all-no-pagination", { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
    }
}


export const presentationPost = async<T>(getForms: T): Promise<string> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await presentationApi.post("", getForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const presentationPut = async<T>(id: number, updateForms: T): Promise<string> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await presentationApi.put(`/${id}`, updateForms, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const presentationDelete = async (id: number): Promise<string> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await presentationApi.delete(`/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const presentationById = async (id: number): Promise<ServiceResponseI<PresentationI>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await presentationApi.get<ServiceResponseI<PresentationI>>(`/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

export const usePresentations = ({
    sorting,
    pagination,
    globalFilter,
    line,
    supplier,
}: PropsGroupsI) => {


    const presentationQuery = useQuery(
        ["presentation", { pagination, sorting, globalFilter, line, supplier }],
        () => getAllPresentations({ pagination, sorting, globalFilter, line, supplier }),
        {
            refetchOnWindowFocus: false,
            keepPreviousData: true
        }
    );






    return {
        presentationQuery,
    };
}